import { Component, Input } from '@angular/core';
import { PeopleLite } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-typing-conversation-message',
  templateUrl: './typing-conversation-message.component.html',
  styleUrls: ['./typing-conversation-message.component.scss'],
  host: { class: 'typing-conversation-message' },
})
export class SharedTypingConversationMessageComponent {
  @Input() typing?: PeopleLite;

  constructor() {}
}
